module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "green",
      "data-image": "../../assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user border-0"
  }, [_c('div', {
    staticClass: "info ml-4"
  }, [_c('span', {
    attrs: {
      "id": "myname"
    }
  }, [_vm._v(_vm._s(_vm.myself))])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink2"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        return _vm.addRFQ();
      }
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("CREATE RFQ")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(../static/img/sidebar-5.jpg)"
    }
  })]), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-fluid p-4",
    attrs: {
      "src": require("../../assets/raefton-logo.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink3"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/contact/edit"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("MY PROFILE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink1"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/rfq/assets"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-bus-front-12"
  }), _vm._v(" "), _c('p', [_vm._v("Assets")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink1"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/rfq/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-delivery-fast"
  }), _vm._v(" "), _c('p', [_vm._v("RFQs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink4"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/shipment/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("SHIPMENTS "), _c('span', {
    attrs: {
      "id": "num_shippments"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink3"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/contact/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("CONTACTS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/auth/login"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-button-power"
  }), _vm._v(" "), _c('p', [_vm._v("SIGN OUT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-panel"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-success btn-fill btn-round btn-icon d-none d-lg-block",
    attrs: {
      "id": "minimizeSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v visible-on-sidebar-regular"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-navicon visible-on-sidebar-mini"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#pablo",
      "id": "test"
    }
  }, [_vm._v(" Assets")])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-controls": "navigation-index",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Add Asset")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row form"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_make"
    }
  }, [_vm._v("Make")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_make",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_model"
    }
  }, [_vm._v("Model")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_model",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_ID"
    }
  }, [_vm._v("Asset ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_ID",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_tractortype"
    }
  }, [_vm._v("Tractor Type")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_tractortype",
      "name": "addAsset_tractortype"
    }
  }, [_c('option', {
    attrs: {
      "value": "tractor"
    }
  }, [_vm._v("Tractor Only")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "straight",
      "selected": ""
    }
  }, [_vm._v("Straight Truck")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_engine"
    }
  }, [_vm._v("Engine Type")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_engine",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_emissions"
    }
  }, [_vm._v("Emissions Profile")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_emissions",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_telematics"
    }
  }, [_vm._v("Telematics ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_telematics",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_GIAI"
    }
  }, [_vm._v("GIAI")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_GIAI",
      "placeholder": ""
    }
  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title mb-3"
  }, [_vm._v("Straight Truck Details")]), _vm._v(" "), _c('div', {
    staticClass: "row form"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techprovider"
    }
  }, [_vm._v("Tech Provider")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_techprovider",
      "name": "addAsset_techprovider"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dummyTracker"
    }
  }, [_vm._v("Dummy Tracker")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bluerover"
    }
  }, [_vm._v("BlueRover")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Tech Provider ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_techproviderID",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_trailertype"
    }
  }, [_vm._v("Trailer Type")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_trailertype",
      "name": "addAsset_trailertype"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dryvan"
    }
  }, [_vm._v("Dry Van")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "flatbed"
    }
  }, [_vm._v("Flatbed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "chassis"
    }
  }, [_vm._v("Container Chassis")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_length"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_length",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_liftgate"
    }
  }, [_vm._v("Lift Gate")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_liftgate",
      "name": "addAsset_liftgate"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_suspension"
    }
  }, [_vm._v("Suspension Type")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_suspension",
      "name": "addAsset_suspension"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Spring"
    }
  }, [_vm._v("Spring")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_tare"
    }
  }, [_vm._v("Tare Weight")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_tare",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_gross"
    }
  }, [_vm._v("Gross Weight")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_gross",
      "placeholder": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_straightGIAI"
    }
  }, [_vm._v("GIAI")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_straightGIAI",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_refrigeration"
    }
  }, [_vm._v("Refrigeration Unit")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "addAsset_refrigeration",
      "name": "addAsset_refrigeration"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "card bg-white mb-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Refrigeration Unit Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Tech Provider ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Tech Provider ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Tech Provider ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "addAsset_techproviderID"
    }
  }, [_vm._v("Tech Provider ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "addAsset_techproviderID",
      "placeholder": "",
      "disabled": ""
    }
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-simple btn-link btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n            © 2018 Raefton\n          ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be948030"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/raw_templates/t_assets_addedit.vue
// module id = 772
// module chunks = 0